import React from "react";
import Popover, { PopoverProps } from "antd/lib/popover";
import { CloseOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import { noop } from "lodash";
import { useTheme } from "themes/useTheme";

interface IProps extends PopoverProps {
  body?: React.ReactNode | React.ReactNode[];
  footer?: React.ReactNode | React.ReactNode[];
}

const Popup = (props: IProps) => {
  const {
    body,
    children,
    title = "",
    onVisibleChange,
    footer,
    ...rest
  } = props;

  const { themeVariables } = useTheme();

  const content = (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: themeVariables.spacing_md,
          minWidth: 220,
          maxHeight: 400,
        }}
      >
        <b>{title}</b>
        <CloseOutlined onClick={() => (onVisibleChange || noop)(false)} />
      </div>
      {body}
      {!!footer && (
        <Divider
          style={{
            marginTop: themeVariables.spacing_lg,
            marginBottom: themeVariables.spacing_md,
          }}
        />
      )}
      {footer}
    </>
  );
  return (
    <Popover content={content} onVisibleChange={onVisibleChange} {...rest}>
      {children}
    </Popover>
  );
};

export default Popup;
